import { VariableSectionCombinedProps } from './types';

const usePresenter = (props: VariableSectionCombinedProps): VariableSectionCombinedProps => {
  return props;
};

export default usePresenter;
